// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"g0-z","sponsoredTooltipWrapper":"h0-z","sponsoredTooltip":"i0-z","newCard":"j0-z"};